import { IonBackButton, IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonMenuButton, IonModal, IonNavLink, IonPage, IonPicker, IonRouterLink, IonRow, IonSearchbar, IonSpinner, IonText, IonTitle, IonToggle, IonToolbar, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import './Pump.css';
import { useEffect, useState, useRef } from 'react';
import { AxiosResponse } from 'axios';
import getApi from '../../api';
import EnvironmentBadge from '../../components/EnvironmentBadge';
import { cellularOutline, cloudOutline, powerOutline, settingsOutline, people } from 'ionicons/icons';
import { useParams } from 'react-router';
import { useHistory } from "react-router-dom";
import Swal from 'sweetalert2'
import PdfReportCard from '../../components/pdfreport';
import CountdownButton from '../../components/CountdownButton';
import vltAquaDrive from '../../img/vlt_aqua_drive.jpg';
import plcWebp from '../../img/plc.webp';

const Pump: React.FC = () => {

  const [me, setMe] = useState({} as any);
  const { id, userId } = useParams<{ id: string, userId: string }>();
  const [pump, setPump] = useState([] as any);
  const [pumpLog, setPumpLog] = useState([] as any);
  const [pumpFlowLog, setPumpFlowLog] = useState([] as any);
  const [showModal, setShowModal] = useState(false);
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [searchUserQuery, setSearchUserQuery] = useState('');
  const [userResults, setUserResults] = useState<any[]>([]);
  const [isSearchingUser, setIsSearchingUser] = useState(false);
  const history = useHistory();
  const [value, setValue] = useState<string | undefined>();
  const [pulseValue, setPulseValue] = useState<string>('');
  const [p_id, setp_id] = useState<string | undefined>();
  const [isPulseSaving, setIsPulseSaving] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('');
  const userAction = useRef(false);

  const [historicalAlarms, setHistoricalAlarms] = useState({ results: [], count: 0 } as any);
  const [alarmPage, setAlarmPage] = useState(1);
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    return d.toISOString().split('T')[0];
  });
  const [endDate, setEndDate] = useState(() => new Date().toISOString().split('T')[0]);


  const showMessage = () => {
    Swal.fire({
      title: 'Skickat!',
      text: 'Komandot är nu skickat till pumpen.',
      icon: 'success',
      confirmButtonText: 'Stäng',
      heightAuto: false
    });
  }

  const searchUsers = (query: string) => {
    setSearchUserQuery(query);
    if (!query) {
      setUserResults([]);
      return;
    }
    setIsSearchingUser(true);
    getApi().get(`/user/allusers/?is_active=true&vattna=true&search=${encodeURIComponent(query)}`)
      .then((res: AxiosResponse) => {
        setUserResults(res.data.results);
        setIsSearchingUser(false);
      }).catch(() => {
        setIsSearchingUser(false);
      });
  };

  const changeOwner = async (newUserId: number, newUserName: string) => {
    Swal.fire({
      title: 'Byta ägare?',
      text: `Vill du flytta pumpen till ${newUserName}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ja, flytta pumpen',
      cancelButtonText: 'Avbryt',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        getApi().patch(`/bbe/userpumps/${id}/`, { user: newUserId })
          .then(() => {
            Swal.fire({
              title: 'Klart!',
              text: 'Pumpen har bytt ägare.',
              icon: 'success',
              confirmButtonText: 'Stäng',
              heightAuto: false
            });
            setShowOwnerModal(false);
            history.replace('/PumpCustomers'); 
          })
          .catch(() => {
            Swal.fire({
              title: 'Fel!',
              text: 'Gick inte att byta ägare.',
              icon: 'error',
              confirmButtonText: 'Stäng',
              heightAuto: false
            });
          });
      }
    });
  };

  async function sendData(pumpID: string | Blob): Promise<void> {
    const data = new FormData();
    data.append('cID', "2");
    data.append('pID', pumpID);
    data.append('hours', hours);
    data.append('minutes', minutes);
    getApi().post('/bbe/send/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response: AxiosResponse) => {
      console.log(response.status);
      if (response.status === 201) {
        showMessage();
        setHours('');
        setMinutes('');
      } else {
        Swal.fire({
          title: 'Fel!',
          text: 'Något gick fel, försök igen.',
          icon: 'error',
          confirmButtonText: 'Stäng',
          heightAuto: false
        });
      }
      console.log(response.data);
    });
  }

  const increaseValue = () => setValue((prevValue) => ((parseFloat(prevValue || "0") + 0.1).toFixed(1)));
  const decreaseValue = () => setValue((prevValue) => ((parseFloat(prevValue || "0") - 0.1).toFixed(1)));

  const fetchData = async () => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();

    getApi().get(`/bbe/userpumps/${id}/`).then((response: AxiosResponse) => {
      setPump(response.data);
      setPulseValue(response.data.pulse_per_1000l?.toString() || '');
    });

    getApi().get(`/bbe/pumplog/?userpump=${id}&limit=10`).then((response: AxiosResponse) => {
      setPumpLog(response.data);
    });

    getApi().get(`/bbe/getflowlog/?pump=${id}&month=${month}&year=${year}`).then((response: AxiosResponse) => {
      setPumpFlowLog(response.data);
    });
  }



  useIonViewWillEnter(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    fetchData();
    fetchHistoricalAlarms();

    intervalRef.current = setInterval(() => {
      fetchData();
    }, 10000);
  });

  useIonViewWillLeave(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  });

  const fetchHistoricalAlarms = async (page: number = 1) => {
    const limit = 10;
    const offset = (page - 1) * limit;
    getApi().get(`/bbe/userpumps/${id}/alarm-history/?date__gte=${startDate}&date__lte=${endDate}&limit=${limit}&offset=${offset}`).then((response: AxiosResponse) => {
      setHistoricalAlarms(response.data);
    });
  }

  useEffect(() => {
    setAlarmPage(1);
    fetchHistoricalAlarms(1);
  }, [id, startDate, endDate]);

  useEffect(() => {
    fetchHistoricalAlarms(alarmPage);
  }, [alarmPage]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);


  async function savePulsePer1000l() {
    setIsPulseSaving(true);
    getApi().patch(`/bbe/userpumps/${id}/`, {
      pulse_per_1000l: parseInt(pulseValue)
    }).then((response: AxiosResponse) => {
      setIsPulseSaving(false);
      if (response.status === 200 || response.status === 204) {
        showMessage();
        // Update local state to reflect change
        setPump((prev: any) => ({ ...prev, pulse_per_1000l: parseInt(pulseValue) }));
      } else {
        Swal.fire({
          title: 'Fel!',
          text: 'Kunde inte spara värdet.',
          icon: 'error',
          confirmButtonText: 'Stäng',
          heightAuto: false
        });
      }
    }).catch(() => {
      setIsPulseSaving(false);
      Swal.fire({
        title: 'Fel!',
        text: 'Ett oväntat fel uppstod.',
        icon: 'error',
        confirmButtonText: 'Stäng',
        heightAuto: false
      });
    });
  }

  async function sendCommand(command: string, pumpID: string) {
    console.log("Sending command: " + command + " to pump: " + pumpID);
    const data = new FormData();
    data.append('pID', pumpID);
    data.append('cID', command);
    getApi().post('/bbe/send/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response: AxiosResponse) => {
      console.log(response.status);
      if (response.status === 201) {
        showMessage();
      } else {
        Swal.fire({
          title: 'Fel!',
          text: 'Något gick fel, försök igen.',
          icon: 'error',
          confirmButtonText: 'Stäng',
          heightAuto: false
        });
      }
      console.log(response.data);
    });
  }

  function show_b(b_value: number, p_id: string) {
    setp_id(p_id);
    setValue(((b_value / 10).toFixed(1) || "0.0"));
    setShowModal(true);
  }

  async function sendBValue() {
    const data = new FormData();
    if (p_id) {
      data.append('pID', p_id.toString());
    }
    if (value) {
      console.log("Value: " + value);
      data.append('b_value', (parseFloat(value) * 10).toFixed(0));
    }
    data.append('cID', '6');
    getApi().post('/bbe/send/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response: AxiosResponse) => {
      console.log(response.data);
      setShowModal(false);
    });
  }

  function incrementIP(ip: string, incrementBy: number): string {
    const parts = ip.split('.').map(Number);
    if (parts.length !== 4) {
      return 'Invalid IP';
    }

    parts[3] += incrementBy;

    for (let i = 3; i > 0; i--) {
      if (parts[i] > 255) {
        const overflow = Math.floor(parts[i] / 256);
        parts[i] %= 256;
        parts[i - 1] += overflow;
      }
    }

    if (parts[0] > 255) {
      return 'Overflow';
    }

    return parts.join('.');
  }


  return (
    <>
      <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonBackButton />
            </IonButtons>
            <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{pump['name']}</IonTitle>
            <div slot="end" style={{ paddingRight: '8px' }}><EnvironmentBadge /></div>
          </IonToolbar>
        </IonHeader>

        <IonContent fullscreen placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

          {/* Alla värden - view only */}



          <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonCol size="12" size-sm="6" size-xl="3" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Styrning</IonCardTitle>
                  </IonCardHeader>

                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol class="status_name" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          Status:
                        </IonCol>
                        <IonCol class="status" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          {(() => {
                            const status = pump['status']?.toLowerCase();
                            let color = 'medium';
                            let icon = cloudOutline;
                            let text = pump['status'] || 'Okänd';

                            if (status === 'on') {
                              color = 'success';
                              icon = powerOutline;
                              text = 'Igång';
                            } else if (status === 'off') {
                              color = 'danger';
                              icon = powerOutline;
                              text = 'Stoppad';
                            } else if (status === 'online') {
                              color = 'success';
                              icon = cloudOutline;
                              text = 'Online';
                            } else if (status === 'offline') {
                              color = 'danger';
                              icon = cloudOutline;
                              text = 'Offline';
                            }

                            return (
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <IonBadge color={color} style={{ padding: '6px 16px', borderRadius: '12px', fontSize: '1em' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  {text.toUpperCase()}
                                </IonBadge>
                              </div>
                            );
                          })()}
                        </IonCol>
                      </IonRow>

                      {pump['type'] === 'mqtt' &&
                        <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonCol class="status_name" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            Livedata:
                          </IonCol>
                          <IonCol class="status" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <CountdownButton pumpId={pump['id']} token={window.localStorage.getItem("token") || ""} />
                          </IonCol>
                        </IonRow>
                      }

                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonButton onClick={() => {
                            const commands = pump['pump']['commands'];
                            const startCommand = commands.find((command: { name: string; }) => command.name === 'Start');
                            const startCommandId = startCommand ? startCommand.id : null;
                            sendCommand(startCommandId, pump['id']);
                          }} className="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonIcon slot="icon-only" icon={powerOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                          </IonButton>
                        </IonCol>
                        <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonButton onClick={() => {
                            const commands = pump['pump']['commands'];
                            const startCommand = commands.find((command: { name: string; }) => command.name === 'Stopp');
                            const startCommandId = startCommand ? startCommand.id : null;
                            sendCommand(startCommandId, pump['id']);
                          }} className="stop" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonIcon slot="icon-only" icon={powerOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                          </IonButton>
                        </IonCol>
                      </IonRow>

                      <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonItem lines="full" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <h2 style={{ fontWeight: 'bold' }}>Autostart</h2>
                            <p>Pumpen startar automatiskt vid behov</p>
                          </IonLabel>
                          <IonToggle
                            slot="end"
                            checked={pump['autostart'] == 1}
                            onPointerDown={() => { userAction.current = true; }}
                            onKeyDown={() => { userAction.current = true; }}
                            onIonChange={(e) => {
                              if (!userAction.current) return;
                              userAction.current = false;

                              const checked = e.detail.checked;
                              const currentInApi = pump['autostart'] == 1;
                              if (checked === currentInApi) return;

                              Swal.fire({
                                title: checked ? 'Aktivera Autostart?' : 'Inaktivera Autostart?',
                                text: checked ? 'Vill du aktivera automatiskt startläge?' : 'Vill du stänga av automatiskt startläge?',
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Ja',
                                cancelButtonText: 'Avbryt',
                                heightAuto: false
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  sendCommand(checked ? '8' : '9', pump['id']);
                                } else {
                                  // Återställ togglen om man avbryter
                                  setPump((prev: any) => ({ ...prev, autostart: currentInApi ? 1 : 0 }));
                                }
                              });
                            }}
                            placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                          />
                        </IonItem>

                        <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <h2 style={{ fontWeight: 'bold' }}>Slavpump</h2>
                            <p>Aktivera eller inaktivera slavpump i systemet</p>
                          </IonLabel>
                          <IonToggle
                            slot="end"
                            checked={pump['slavpump'] == 1}
                            onPointerDown={() => { userAction.current = true; }}
                            onKeyDown={() => { userAction.current = true; }}
                            onIonChange={(e) => {
                              if (!userAction.current) return;
                              userAction.current = false;

                              const checked = e.detail.checked;
                              const currentInApi = pump['slavpump'] == 1;
                              if (checked === currentInApi) return;

                              Swal.fire({
                                title: checked ? 'Aktivera Slavpump?' : 'Inaktivera Slavpump?',
                                text: checked ? 'Vill du aktivera slavpumpen i systemet?' : 'Vill du inaktivera slavpumpen i systemet?',
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Ja',
                                cancelButtonText: 'Avbryt',
                                heightAuto: false
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  sendCommand(checked ? '10' : '11', pump['id']);
                                } else {
                                  // Återställ togglen om man avbryter
                                  setPump((prev: any) => ({ ...prev, slavpump: currentInApi ? 1 : 0 }));
                                }
                              });
                            }}
                            placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                          />
                        </IonItem>
                        <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonButton
                            expand="block"
                            color="warning"
                            style={{ width: '100%', height: '80px', fontSize: '1.2em', '--color': 'black', fontWeight: 'bold' }}
                            onClick={() => sendCommand('7', pump['id'])}
                            placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                          >
                            Återställ larm
                          </IonButton>
                        </IonItem>
                      </IonList>

                    </IonGrid>
                  </IonCardContent>
                </IonCard>

                {pump['type'] === 'mqtt' &&
                  <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Körtid</IonCardTitle>
                    </IonCardHeader>

                    <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonText color="secondary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <h2>Här kan du sätta körtid. Tiden du sätter här kommer gälla nästa gång du startar pumpen. Sätter du 2 timmar och 30 minuter kommer pumpen nästa gång du startar den köra 2 timmar och 30 minuter sen stänger den automatiskt av sig.</h2>
                            </IonText>
                          </IonCol>
                        </IonRow>

                        <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonInput
                              type="number"
                              value={hours || ''}
                              placeholder="Timmar"
                              onIonChange={e => {
                                const value = e.detail.value || '';
                                if (Number(value) <= 99) {
                                  setHours(value);
                                } else {
                                  setHours('99');
                                }
                              }}
                              style={{ fontSize: '20px', height: '50px' }} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}                      ></IonInput>
                          </IonCol>
                          <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonInput
                              type="number"
                              value={minutes || ''}
                              placeholder="Minuter"
                              onIonChange={e => {
                                const value = e.detail.value || '';
                                if (Number(value) <= 99) {
                                  setMinutes(value);
                                } else {
                                  setMinutes('99');
                                }
                              }}
                              style={{ fontSize: '20px', height: '50px' }} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}                    ></IonInput>
                          </IonCol>
                          <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonButton onClick={() => sendData(pump['id'])} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Skicka</IonButton>
                          </IonCol>
                        </IonRow>

                      </IonGrid>
                    </IonCardContent>
                  </IonCard>


                }

                {pump['type'] === 'mqtt' &&
                  <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>IP Adresser</IonCardTitle>
                    </IonCardHeader>

                    <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Router</IonLabel>
                                {pump['ipsubnets'] && pump['ipsubnets'].length > 0 ? (
                                  <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{incrementIP(pump['ipsubnets'][0].networkaddress, 1)}</IonLabel>
                                ) : (
                                  <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>N/A</IonLabel>
                                )}
                              </IonItem>
                              <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>PLC</IonLabel>
                                {pump['ipsubnets'] && pump['ipsubnets'].length > 0 ? (
                                  <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{incrementIP(pump['ipsubnets'][0].networkaddress, 2)}</IonLabel>
                                ) : (
                                  <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>N/A</IonLabel>
                                )}
                              </IonItem>
                              <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>HMI</IonLabel>
                                {pump['ipsubnets'] && pump['ipsubnets'].length > 0 ? (
                                  <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{incrementIP(pump['ipsubnets'][0].networkaddress, 3)}</IonLabel>
                                ) : (
                                  <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>N/A</IonLabel>
                                )}
                              </IonItem>
                              <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Nätmask</IonLabel>
                                {pump['ipsubnets'] && pump['ipsubnets'].length > 0 ? (
                                  <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{pump['ipsubnets'][0].netmask}</IonLabel>
                                ) : (
                                  <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>N/A</IonLabel>
                                )}
                              </IonItem>
                            </IonList>
                          </IonCol>
                        </IonRow>

                      </IonGrid>
                    </IonCardContent>
                  </IonCard>
                }

                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Parametrar</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonButton fill="clear" className="parameter-btn" routerLink={`/pump/${userId}/${id}/plc-parameters`} style={{ height: 'auto', padding: '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                              <img src={plcWebp} alt="PLC" style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '5px' }} />
                              <IonLabel style={{ whiteSpace: 'normal' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Parametrar PLC</IonLabel>
                              <IonText color="medium" style={{ fontSize: '0.8em' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>S7-1200</IonText>
                            </div>
                          </IonButton>

                        </IonCol>
                        <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonButton fill="clear" className="parameter-btn" routerLink={`/pump/${userId}/${id}/vlt-parameters`} style={{ height: 'auto', padding: '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                              <img src={vltAquaDrive} alt="VLT AQUA Drive" style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '5px' }} />
                              <IonLabel style={{ whiteSpace: 'normal' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>VLT parametrar</IonLabel>
                              <IonText color="medium" style={{ fontSize: '0.8em' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>VLT® AQUA Drive FC 202</IonText>
                            </div>
                          </IonButton>
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  </IonCardContent>
                </IonCard>

                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Administration</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonItem lines="none" button onClick={() => { setShowOwnerModal(true); searchUsers(''); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonIcon icon={people} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                        <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <h2 style={{ fontWeight: 'bold' }}>Byt ägare på pump</h2>
                          <p>Flytta denna pump till en annan kund</p>
                        </IonLabel>
                      </IonItem>
                    </IonList>
                  </IonCardContent>
                </IonCard>

              </IonCol>

              <IonCol size="12" size-sm="6" size-xl="3" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Avläsningar</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    {pump['type'] !== 'sms' && <><IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      {pump['pump'] && pump['pump']['id'] !== 6 && <>
                        <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonCard className="card-min" onClick={() => show_b(pump['b_value'], pump['id'])} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Valt Tryck</IonCardTitle>
                            </IonCardHeader>
                            <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonLabel class="number" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{(((pump['b_value'] as number) / 10).toFixed(1) || 0.00)}</IonLabel>
                            </IonCardContent>
                          </IonCard>
                        </IonCol></>}

                      {pump['pump'] && pump['pump']['id'] !== 6 && <>
                        <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonCard className="card-min" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Aktivt Tryck</IonCardTitle>
                            </IonCardHeader>
                            <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonLabel class="number" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{(((pump['r_value'] as number) / 10).toFixed(1) || 0.00)}</IonLabel>

                            </IonCardContent>
                          </IonCard>
                        </IonCol>
                      </>}
                    </IonRow><IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        {pump['pump'] && pump['pump']['id'] !== 6 && <>
                          <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCard className="card-min" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Hz Motor</IonCardTitle>
                              </IonCardHeader>
                              <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonLabel class="number" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{((pump['hz_value'] as number) || 0)}</IonLabel>

                              </IonCardContent>
                            </IonCard>
                          </IonCol> </>}

                        <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonCard className="card-min" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Flöde</IonCardTitle>
                            </IonCardHeader>
                            <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonLabel class="number" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{((pump['flow_minute'] as number) || 0)}</IonLabel>
                            </IonCardContent>
                          </IonCard>
                        </IonCol>
                      </IonRow>
                      {pump['water_level'] !== null && pump['water_level'] !== undefined && pump['water_level'] !== 0 && pump['water_level'] !== "" && (
                        <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonCol size="12" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Vattennivå</IonCardTitle>
                              </IonCardHeader>
                              <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <div style={{ position: 'relative', textAlign: 'center', height: '300px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                  <svg width="120" height="220" viewBox="0 0 120 220">
                                    <defs>
                                      <linearGradient id={`waterGradient-${pump['id']}`} x1="0%" y1="0%" x2="0%" y2="100%">
                                        <stop offset="0%" stopColor="#00d2ff" />
                                        <stop offset="100%" stopColor="#3a7bd5" />
                                      </linearGradient>
                                      <filter id="glow">
                                        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
                                        <feMerge>
                                          <feMergeNode in="coloredBlur"/>
                                          <feMergeNode in="SourceGraphic"/>
                                        </feMerge>
                                      </filter>
                                    </defs>
                                    
                                    {/* Glass Tube background */}
                                    <rect x="50" y="10" width="20" height="180" rx="10" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
                                    
                                    {/* Water Level */}
                                    <rect 
                                      x="52" 
                                      y={190 - (176 * (Math.min(Number(pump['water_level']), 100) / 100))} 
                                      width="16" 
                                      height={176 * (Math.min(Number(pump['water_level']), 100) / 100)} 
                                      rx="8" 
                                      fill={`url(#waterGradient-${pump['id']})`}
                                      filter="url(#glow)"
                                      style={{ transition: 'all 1s ease-in-out' }}
                                    />
                                    
                                    {/* Ticks */}
                                    {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(tick => {
                                      const y = 190 - (tick * 1.76);
                                      const isMajor = tick % 20 === 0;
                                      return (
                                        <g key={tick}>
                                          <line 
                                            x1={isMajor ? 40 : 45} 
                                            y1={y} 
                                            x2={50} 
                                            y2={y} 
                                            stroke="var(--ion-text-color)" 
                                            strokeWidth={isMajor ? 1.5 : 0.5} 
                                            opacity={isMajor ? 0.8 : 0.4}
                                          />
                                          {isMajor && (
                                            <text x="35" y={y + 4} fontSize="10" fill="var(--ion-text-color)" opacity="0.8" textAnchor="end">{tick}</text>
                                          )}
                                        </g>
                                      );
                                    })}
                                    
                                    <text x="75" y="195" fontSize="10" fill="var(--ion-text-color)" opacity="0.6">0m</text>
                                    <text x="75" y="15" fontSize="10" fill="var(--ion-text-color)" opacity="0.6">100m</text>
                                  </svg>
                                  
                                  <div style={{ marginTop: '10px' }}>
                                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: 'var(--ion-text-color)', marginBottom: '2px' }}>m</div>
                                    <div style={{ backgroundColor: '#ccc', color: '#000', padding: '2px 10px', borderRadius: '4px', fontSize: '18px', fontWeight: 'bold', display: 'inline-block', minWidth: '60px' }}>
                                      {pump['water_level']}
                                    </div>
                                  </div>

                                  <div style={{ display: 'flex', gap: '15px', marginTop: '15px', justifyContent: 'center' }}>
                                    <div style={{ textAlign: 'center' }}>
                                      <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--ion-color-medium, #888)' }}>Min idag</div>
                                      <div style={{ fontSize: '15px', fontWeight: 'bold', color: 'var(--ion-text-color)' }}>
                                        {pump['waterlevel_min'] !== undefined && pump['waterlevel_min'] !== null ? `${pump['waterlevel_min']} m` : '—'}
                                      </div>
                                    </div>
                                    <div style={{ width: '1px', backgroundColor: 'rgba(255,255,255,0.15)', alignSelf: 'stretch' }}></div>
                                    <div style={{ textAlign: 'center' }}>
                                      <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--ion-color-medium, #888)' }}>Max idag</div>
                                      <div style={{ fontSize: '15px', fontWeight: 'bold', color: 'var(--ion-text-color)' }}>
                                        {pump['waterlevel_max'] !== undefined && pump['waterlevel_max'] !== null ? `${pump['waterlevel_max']} m` : '—'}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </IonCardContent>
                            </IonCard>
                          </IonCol>
                        </IonRow>
                      )}
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size="12" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Antal pulser per kubik vatten (1000L)</IonLabel>
                            <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                              <IonInput
                                type="number"
                                value={pulseValue}
                                onIonChange={e => setPulseValue(e.detail.value!)}
                                placeholder="Ange antal pulser"
                                onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                              />
                              <IonButton
                                slot="end"
                                onClick={savePulsePer1000l}
                                disabled={isPulseSaving}
                                placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                              >
                                {isPulseSaving ? <IonSpinner name="crescent" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /> : 'Spara'}
                              </IonButton>
                            </div>
                          </IonItem>
                        </IonCol>
                      </IonRow>
                    </>
                    }
                  </IonCardContent>
                </IonCard>
                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Aktiva larm</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      {pump.alarms && pump.alarms.length > 0 ? (
                        pump.alarms.slice(-10).reverse().map((alarm: any) => (
                          <IonItem key={alarm.id} color={alarm.msg.includes("Högtrycksvakt") ? "danger" : "warning"} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <b>{alarm.date} {alarm.time}</b><br />
                              {alarm.msg}
                            </IonLabel>
                          </IonItem>
                        ))
                      ) : (
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Inga larm registrerade</IonLabel>
                        </IonItem>
                      )}
                    </IonList>
                  </IonCardContent>
                </IonCard>

                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Larmhistorik</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size="6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Från</IonLabel>
                          <IonInput type="date" value={startDate} onIonChange={e => setStartDate(e.detail.value!)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                        </IonCol>
                        <IonCol size="6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Till</IonLabel>
                          <IonInput type="date" value={endDate} onIonChange={e => setEndDate(e.detail.value!)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                    <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      {historicalAlarms?.results && historicalAlarms.results.length > 0 ? (
                        <>
                          <div style={{ padding: '10px', textAlign: 'center', fontSize: '0.9em', color: '#666' }}>
                            Visar {((alarmPage - 1) * 10) + 1} - {Math.min(alarmPage * 10, historicalAlarms.count)} av <b>{historicalAlarms.count}</b> larm
                          </div>
                          {historicalAlarms.results.map((alarm: any) => (
                            <IonItem key={alarm.id} color={alarm.msg && alarm.msg.includes("Högtrycksvakt") ? "danger" : "warning"} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <b>{alarm.date} {alarm.time}</b><br />
                                {alarm.msg}
                              </IonLabel>
                            </IonItem>
                          ))}
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                            <IonButton
                              fill="clear"
                              disabled={alarmPage === 1}
                              onClick={() => setAlarmPage(p => p - 1)}
                              placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              Föregående
                            </IonButton>
                            <IonText placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Sida {alarmPage}</IonText>
                            <IonButton
                              fill="clear"
                              disabled={alarmPage * 10 >= historicalAlarms.count}
                              onClick={() => setAlarmPage(p => p + 1)}
                              placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              Nästa
                            </IonButton>
                          </div>
                        </>
                      ) : (
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Inga larm registrerade för vald period</IonLabel>
                        </IonItem>
                      )}
                    </IonList>
                  </IonCardContent>
                </IonCard>


              </IonCol>
              <IonCol size="12" size-sm="6" size-xl="3" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Historik</IonCardTitle>
                  </IonCardHeader>

                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      {pumpLog["results"]?.map((log: any) => {
                        let color = "medium";
                        let icon = cloudOutline;
                        let text = log.msg;

                        if (log.msg === "on") {
                          color = "success";
                          icon = powerOutline;
                          text = "Pump startad";
                        } else if (log.msg === "off") {
                          color = "danger";
                          icon = powerOutline;
                          text = "Pump stoppad";
                        } else if (log.msg === "ONLINE") {
                          color = "success";
                          icon = cloudOutline;
                          text = "Uppkopplad (ONLINE)";
                        } else if (log.msg === "OFFLINE") {
                          color = "danger";
                          icon = cloudOutline;
                          text = "Nerkopplad (OFFLINE)";
                        }

                        return (
                          <IonItem key={log.id} lines="full" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonIcon slot="start" icon={icon} color={color} style={{ fontSize: '24px', marginRight: '16px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <h2 style={{ fontWeight: 'bold', color: `var(--ion-color-${color})` }}>{text}</h2>
                              <p style={{ marginTop: '4px' }}>{log.date} kl. {log.time}</p>
                            </IonLabel>
                          </IonItem>
                        );
                      })}
                    </IonList>
                  </IonCardContent>
                </IonCard>
                <PdfReportCard pumpId={id} />
              </IonCol>




              <IonCol size="12" size-sm="6" size-xl="3" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Flödeslogg</IonCardTitle>
                  </IonCardHeader>

                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      {pumpFlowLog["results"]?.map((log: any) => (
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{log.date}</IonLabel>
                          <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{log.flow !== null ? log.flow : 0}m3</IonLabel>
                        </IonItem>
                      ))}
                    </IonList>
                  </IonCardContent>
                </IonCard>

                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Flödeshistorik</IonCardTitle>
                  </IonCardHeader>

                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      {pumpFlowLog["total"]?.map((log: any) => (
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{log.when}</IonLabel>
                          <IonLabel class="dateholder" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{log.flow !== null ? log.flow : 0}m3</IonLabel>
                        </IonItem>
                      ))}
                    </IonList>
                  </IonCardContent>
                </IonCard>
              </IonCol>

            </IonRow>
          </IonGrid>

          <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)} initialBreakpoint={0.25} breakpoints={[0, 0.25, 0.5, 0.75]} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton className="set_bor_button" onClick={increaseValue} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>+</IonButton></IonCol>
                <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonInput class="set_bor" value={value} readonly placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>
                <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton className="set_bor_button" onClick={decreaseValue} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>-</IonButton></IonCol>
              </IonRow>
              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonButton className="save_button" expand="block" onClick={() => sendBValue()} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Spara</IonButton>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonModal>

          <IonModal isOpen={showOwnerModal} onDidDismiss={() => setShowOwnerModal(false)} initialBreakpoint={0.75} breakpoints={[0, 0.25, 0.5, 0.75]} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonToolbar color="light" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Byt ägare</IonTitle>
                <IonButtons slot="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonButton onClick={() => setShowOwnerModal(false)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Stäng</IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonSearchbar
                placeholder="Sök användare"
                value={searchUserQuery}
                onIonChange={e => searchUsers(e.detail.value || '')}
                debounce={500}
                animated={true}
                onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
              />
              {isSearchingUser && (
                <div className="ion-text-center ion-padding">
                  <IonSpinner placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                </div>
              )}
              <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                {userResults.map((user: any) => (
                  <IonItem button key={user.id} onClick={() => changeOwner(user.id, user.name)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <h2>{user.name}</h2>
                      <p>{user.company_name}</p>
                    </IonLabel>
                  </IonItem>
                ))}
                {!isSearchingUser && searchUserQuery && userResults.length === 0 && (
                  <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonLabel className="ion-text-center color-medium" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Inga användare hittades</IonLabel>
                  </IonItem>
                )}
              </IonList>
            </IonContent>
          </IonModal>

        </IonContent>
      </IonPage></>
  );
};

export default Pump;
